import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/**
 * Bus events emitted by the identity module's workspace command handlers.
 * Per ADR 0015 §PII: payloads carry machine fields only — no email, name,
 * address. The audit row references the aggregate by id; resolution to a
 * person happens through the identity database (subject to IMM-7 retention).
 */

export const WorkspaceCreatedPayloadSchema = z.object({
  workspaceId: z.string().min(1),
  createdBy: z.string().min(1),
  ownerMemberId: z.string().min(1),
});

export const WorkspaceWebAddressChangedPayloadSchema = z.object({
  workspaceId: z.uuid(),
  previousWebAddress: z.string().nullable(),
  webAddress: z.string(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
